import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import PasswordInput from 'components/Inputs/PasswordInput'
import PasswordStrengthBar from 'components/PasswordStrengthBar'
import passwordValidator from 'validators/passwordValidator'
import { ReactComponent as ButtonLoading } from 'icons/loading.svg'
import { Formik } from 'formik'

import {
  Container,
  Form,
  SubTitle,
  Row,
  FormField,
  InfoText,
  WarningText,
  Button
} from '../styles'

export default function ChangePassword () {
  const [showOkDialog, setShowOkDialog] = useState (false)
  const company = AuthService.getUser ()
  const token = AuthService.getToken ()
  const navigate = useNavigate ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const toggleOkDialog = () => setShowOkDialog (!showOkDialog)

  return (
    <Container>
      <Formik
        validationSchema={passwordValidator}
        initialValues={{
          'password': '',
          'password_confirmation': ''
        }}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            await cutileiApi.put (
              `/companies/${company.id}`,
              { password: values.password },
              requestConfig
            )

            setSubmitting (false)
            toggleOkDialog ()
          } catch (error) {
            setSubmitting (false)
            logApiError (error)
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        }) => (
          <Form onSubmit={handleSubmit} style={{width: 480}}>
            <SubTitle>Alterar senha</SubTitle>
            <Row>
              <FormField style={{margin: 0}}>
                <PasswordInput
                  placeholder='Nova senha'
                  value={values.password}
                  onChange={handleChange ('password')}
                  onBlur={handleBlur ('password')}
                />
                {touched.password && errors.password && (
                  <WarningText>
                    {errors.password}
                  </WarningText>
                )}
                <PasswordStrengthBar password={values.password}/>
              </FormField>
            </Row>
            <Row>
              <FormField style={{margin: 0}}>
                <PasswordInput
                  placeholder='Confirmar senha'
                  value={values.password_confirmation}
                  onChange={handleChange ('password_confirmation')}
                  onBlur={handleBlur ('password_confirmation')}
                />
                {touched.password_confirmation && errors.password_confirmation && (
                  <WarningText>
                    {errors.password_confirmation}
                  </WarningText>
                )}
              </FormField>
            </Row>
            <InfoText style={{marginBottom: 15}}>
              Ao alterar sua senha, você será deslogado de todos os dispositivos onde estiver logado, exceto este.
            </InfoText>
            <Button type='submit' disabled={isSubmitting}>
              {isSubmitting ? <ButtonLoading/> : 'Alterar senha'}
            </Button>
            <AlertDialog
              visible={showOkDialog}
              title='Sucesso'
              message='Senha alterada!'
              confirmText='Ok'
              onConfirm={() => navigate ('/company', { replace: true })}
              onClose={() => navigate ('/company', { replace: true })}
            />
          </Form>
        )}
      </Formik>
    </Container>
  )
}
